<template>
  <div class="main-wrapper-container row-list-container publication-page">
    <header-title :main-title="mainTitle" :btn-info="btnInfo"/>
    <label class="publication-filter">Показать
      <select v-model="publicationFilter" @change="changePublicationFilter">
        <option v-for="filter in publicationFilters" :key="filter.value" :value="filter.value">{{ filter.title }}</option>
      </select>
    </label>
    <p v-if="loadError" class="publication-load-error" role="alert">{{ loadError }}</p>
    <template-pagination
        v-else
        @changePage="changePage"
        @changeValue="changeValueSearch"
        :is-loading="isLoadingItems"
        :active-page="pagination.page"
        :page-total="pagination.total"
    >
      <TableView
          :headers="headers"
          :items="materialsWithLabels"
          :is-active-search="false"
          @edit="item => openEditMaterial(item.id)"
          @delete="item => openModalDeleteMaterial(item)"
      />
    </template-pagination>
  </div>
</template>

<script>
import HeaderTitle from "@/components/entities/HeaderTitle.vue";
import TemplatePagination from "@/components/entities/pagination/TemplatePagination.vue";
import paginationMixin from "@/mixins/pagination.mixin";
import RowItem from "@/components/entities/items/RowItem.vue";
import modalAgreement from "@/mixins/modals/modalAgreement";
import TableView from "@/components/shared/table/TableView.vue";
import {api} from "@/middleware/api";
import { PUBLICATION_FILTERS, publicationLabel, displayMoscow } from "@/services/publication-schedule.mjs";
import { adminListLoadError } from "@/services/admin-session.mjs";

export default {
  name: "NewsPage",
  components: {TableView, RowItem, TemplatePagination, HeaderTitle},
  mixins: [paginationMixin, modalAgreement],
  data() {
    return {
      items: [],
      publicationFilter: "published",
      publicationFilters: PUBLICATION_FILTERS,
      headers: [
        {text: 'Название', value: 'title'},
        {text: 'URL', value: 'url'},
        {text: 'Дата публикации', value: 'publishedAt'},
        {text: 'Статус', value: 'publicationLabel'},
        {text: 'По расписанию', value: 'scheduledLabel'},
        {text: 'Тип', value: 'type'},
      ],
      isLoadingItems: false,
      mainTitle: 'Материалы',
      btnInfo: {
        text: 'Добавить материал',
        action: () => this.openCreateMaterial()
      },
      loadError: '',
      timer: null
    }
  },
  created() {
    this.fetchInfo();
  },
  computed: {
    materialsWithLabels() {
      return this.items.map(item => ({
        ...item,
        updatedAt: this.formatDate(item.updatedAt),
        title: item.translations[0]?.title,
      }))
    }
  },
  methods: {
    changePublicationFilter() { this.pagination.page = 1; this.fetchInfo(); },
    async fetchInfo() {
      this.loadError = '';
      this.isLoadingItems = true;
      this.IS_GLOBAL_LOADING(true)
      try {
        const { data } = await api.dashboard.adminMaterialsControllerFindAll({
          ...this.search !== ''
              ? { title: this.search }
              : {},
          publicationFilter: this.publicationFilter,
          limit: this.pagination.limit,
          offset: this.activeOffset
        })
        this.pagination.offset = data.offset;
        this.pagination.total = Math.ceil(data.total / this.pagination.limit)
        this.items = data.items.map(item => ({
          ...item,
          publicationLabel: publicationLabel(item),
          scheduledLabel: displayMoscow(item.publication?.scheduledAt),
          publishedAt: item.publishedAt ? this.formatDate(item.publishedAt) : "—"
        }));
      } catch (error) {
        this.items = [];
        this.pagination.offset = 0;
        this.pagination.total = 0;
        this.loadError = adminListLoadError(error.response?.status, 'список материалов');
        if (this.loadError) this.alertError(this.loadError);
      } finally {
        this.isLoadingItems = false;
        this.IS_GLOBAL_LOADING(false)
      }
    },
    openCreateMaterial() {
      this.$router.push({
        name: 'material-create'
      })
    },
    openEditMaterial(id) {
      this.$router.push({
        name: 'material-edit',
        params: {
          id
        }
      })
    },
    async removeMaterial(item) {
      this.items = this.items.filter(m => m.id !== item.id)
      await api.dashboard.adminMaterialsControllerRemove(item.id)
    }
  }
}
</script>

<style scoped>
.publication-filter { display: flex; align-items: center; gap: 12px; margin: 16px 0; }
.publication-filter select { padding: 10px 16px; border: 1px solid #738a78; border-radius: 8px; background: white; }
.publication-load-error { margin: 24px 0; color: var(--color-red); }

</style>
